const data={
    bannerList:[//轮播
        {
            bannerid:"",
            imgUrl:require('assets/images/solution/emsb/banner_one.png'),
            jumpUrl:"",
        }
    ],
    options:[
        {
            title:'背景情况',
            content:`       中国有一句古话,叫做”民以食为天”.吃一直是百姓生死攸关的大事,是最基本的民生问题,古今中外,概莫能外.随着我国经济的快速发展和人民生活水平的不断提高,城乡居民对食品质量安全提出了越来越高的要求;科学技术的发展也给食品安全带来了新的问题和挑战.因此,人们在强调”民以食为天”的同时,又在呼吁”食以安为先”.食品安全己成为社会普遍关注的热点问题。
       随着我国教育事业的快速发展，教育投入的不断加大，学校食堂无论从硬件改造还是软件建设都有了很大进步，食品安全与营养健康管理水平在不断提高。食堂作为师生饮食、活动的重地，食堂的卫生安全关系到师生的生命健康安全以及社会稳定发展。
       目前的校园食堂管理普遍采用自主经营的服务模式和社会招标的承包模式，无论是学校自己招聘人员经营还是外包，都存在一定的经营风险，食品安全质量难以把控。
       对此，国家出台了一系列政策，《国务院食品安全办等14部门关于提升餐饮业质量安全水平的意见 》、国务院食品安全委员会《关于开展食品安全督查工作的通知》、国务院食品安全办等6部门《关于进一步加强学校校园及周边食品安全工作的意见》、国家食品药品监督管理总局《关于进一步加强学校食堂食品安全工作的通知》等，都对校餐安全做出了明确规定。
       为贯彻落实习近平总书记对食品安全工作提出的“四个最严”要求，加强对学校食品安全与营养健康的监督管理，2019年3月，教育部、市场监管总局和卫生健康委联合印发了《学校食品安全与营养健康管理规定》（以下简称《规定》）。
       《规定》要求，学校集中用餐实行预防为主、全程监控、属地管理、学校落实的原则，建立教育、食品安全监督管理、卫生健康等部门分工负责的工作机制。县级以上地方人民政府依法统一领导、组织、协调学校食品安全监督管理工作以及食品安全突发事故应对工作，教育部门应当指导和督促学校建立健全食品安全与营养健康相关管理制度，食品安全监督管理部门应当加强学校集中用餐食品安全监督管理，卫生健康主管部门应当组织开展校园食品安全风险和营养健康监测。
       《规定》强调，学校集中用餐应当坚持公益便利的原则，围绕采购、贮存、加工、配送、供餐等关键环节，健全学校食品安全风险防控体系。学校自主经营的食堂应当坚持公益性原则，不以营利为目的。实施营养改善计划的农村义务教育学校食堂不得对外承包或者委托经营。学校食堂应当依法取得食品经营许可证，建立食品安全与营养健康状况自查制度、从业人员健康管理和培训等制度，并建立食品安全追溯体系等。有条件的学校食堂应当做到明厨亮灶，运用互联网等信息化手段，加强对食品来源、采购、加工制作全过程的监督。`,
        },
        {
            title:"校园食堂食品安全现状",//名字
            content:`       食堂作为学校师生饮食、活动的重地，食堂的卫生安全关系到师生的生命健康安全以及社会稳定发展。食品以其自身的易腐性、生鲜性，加之其生产、供应、加工等过程，很容易造成食品安全风险。
       各地在学校食堂管理及学校食品安全管理方面存在以下问题： 
       1.学校食堂缺乏完善的安全管理制度 
       从当前学校食堂安全管理现状来看，缺乏系统性、完善性的食堂安全管理工作体系，缺少必要的技术手段保证制度的执行，影响到食堂安全管理的进一步开展。
       部分学校食堂虽然建立了一套比较完善的管理规定，但是却由于保证其得到实施的机制相对缺乏，使得那一套看起来比较完善的规定如同虚设。
       2.学校食堂工作人员缺乏食品安全意识 
       从当前学校食堂安全管理现状来看，部分食堂工作人员由于缺乏安全管理意识以及能力，使食堂安全管理工作停留在形式上，未能够达到有效性的开展目的，这进一步影响到食堂安全。
       3.劣质的食材和原料的使用
       由于学生和教职工数量较大，学校食堂选购食材时会遇到很多问题，首先由各地学校分散采购、分散管理，食材供应商规模、质量水平、管理水平有限，甚至部分食材是直接从市场购买，无法保证品质，且无法追踪溯源；食品添加剂存在使用超标等问题。
       4.硬件设施不达标 
       学校食堂每天都需要接待数量众多的学生和教职员工，而在集体就餐模式下，对于餐具、消毒柜、保险柜、留样柜等硬件设施也提出了更高的要求。一部分学校食堂硬件设施投入不足，不达标，缺少相应的卫生安全保证。
       同时设备的智能化程度较低，操作不便，增加了工作强度，从而致使设备利用率降低。
       5.对食堂食品安全监管不力
       解决数量庞大的师生食品供给是一个巨大的工程，很难做到每个食堂每顿饭都详细的了解食品的来源。由于行为难以监督、行为效果难以测量等原因而产生了监督制约机制的不完善。同时实行监管手段传统，需要耗费大量时间、精力，不能形成常态化。在监管主体上，就餐人员的监管主体作用被忽略，使之作用未能得到发挥。`,

        },
		{
            title:"改善策略",//名字
            content:`       构建学校食堂食品安全管理体系，建议从以下几个方面着手：
       1.提升食堂工作人员食品安全意识 
       在学校食堂安全管理工作中，食堂工作人员作为工作实施的主体者，需要不断的提升食堂工作人员的食品安全意识以及食品安全能力，使其能够合理的工作，并以自身能力与素养维护食堂卫生。
       2.做好食品采购工作 
       学校在构建食堂安全管理质量体系中，需要做好食堂食品采购工作，从源头挑选优质的食材。食品采购工作作为食堂安全管理工作的第一环，也是最为重要的一环，需要认真对待。
       3.推进食堂现代化安全管理实施 
       加强对食堂的投入，在食堂的场地、设备、设施上进行补足，打造食堂内外良好的场地，进而为师生用餐提供舒适平台。
       推进食堂现代化安全管理工作的开展，加强智能化监控设备等的运用，加强监督管理工作的实施，提升食堂工作人员工作的安全性、自觉性。 
       4.构建食堂安全管理制度 
       完善食堂安全管理制度，以制度为导向，推进食堂工作的合理性开展。
       5.加强食堂安全监管
       采用智能化、数据化的技术手段，减少监管部门的工作强度，加强学校食堂的经常性卫生监督管理，对食堂布局、卫生设施、操作规范等方面进行审查。充分利用师生的监督作用，在学校食品安全问题上，要加大处罚力度。  
       6.大力宣传食品安全。
       以社会食品质量安全热点问题为主题、利用宣传栏、网络平台等普及食品安全知识，教育学生生活中应当如何选购食品、如何科学安排饮食，发生了损害消费者利益事件是应如何投诉维权等，从而增强食品安全意识、树立健康科学的消费观念、提高风险防范能力。`,

        },
		{
            title:"解决方案",//名字
            content:`       要解决学校食堂精细化管理及食品安全问题，建议从以下方面着手：
       1.构建食品安全管理云平台。
       2.开展校园食材统采统配。
       3.校园食堂管理及物资采购纳入统一监管。

       利用大数据、物联网、人工智能等技术手段，构建一套全方位的学校食堂食品安全管理体系，全面提升地区学校食品安全管理水平，保证食品安全与营养健康十分重要，这不仅是学校师生合理健康饮食的需要，也是学校食堂向现代化发展的需要，更是学校办学质量全面性提升的需要。
       学校食堂食品安全管理云平台包括：
       1、食品安全宣传系统、
       2、食品物资采购溯源系统、
       3、校园食堂运营管理系统、
       4、大数据监管系统。

       开展校园食材统采统配
       为了贯彻《国务院办公厅关于实施农村义务教育学生营养改善计划的意见》（国办发〔2011〕54号），保证学生膳食营养和校园食品卫生安全。

       校园食堂管理及物资采购纳入统一监管
       根据《食品安全法》、《校园食品安全与营养健康管理规定》相关要求，结合实际，有序推进，采用信息化手段将校园食堂管理与物资采购纳入统一监管。

       略……`,
        },
    ],
}

export default data;
